import {filter} from 'rxjs/operators';
import {Component , OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {ActivatedRoute , Router} from '@angular/router';
import {fuseAnimations} from '../../../../core/animations';
import {UserService} from '../../../../core/services/users.service';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import {checkEmailOnServer , emailValidator} from '../../../../core/validators/validators';
import {CheckModalComponent} from '../../check-save-modal/check-modal';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {Observable} from 'rxjs';
import { ToastrService  } from 'ngx-toastr';
import {FuseConfigService} from '../../../../core/services/config.service';
import {FuncionTypeService} from '../../../../core/services/functionType.service';
import {FuseMailDialogComponent} from '../../../../core/components/mail-dialog/mail-dialog.component';


@Component({
    selector: 'user-new-page',
    templateUrl: './user-new.component.html',
    styleUrls: ['./user-new.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class UserNewComponent implements OnInit {
  public language = 'de';
  public formGroup: any = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    roleId: new FormControl('', Validators.required),
    functionTypeId: new FormControl(),
    email: new FormControl('', [emailValidator , checkEmailOnServer, Validators.required]),
    countryId: new FormControl({value: '', disabled: true}, Validators.required),
    cityId: new FormControl({value: '', disabled: true}, Validators.required),
    organizationId: new FormControl({value: '', disabled: true}, Validators.required),
    lang: new FormControl(),
    eCall: new FormControl(),
    phone: new FormControl(),
  });

  public img: any = '';
  public uploadedImg = null;
  public countries = [];
  public cities = [];
  public organizations = [];
  public returnBack;


  public cityIdRoute;
  public orgIdRoute;
  public languages = [ {label: 'Germany' , value: 'de'},  {label: 'English' , value: 'en'} , {label: 'French' , value: 'fr'} ];

  public roles: any = [];
  public functions: any = [];
  public adminRole = '';

  constructor (private userService: UserService , private router: Router ,
               private organizationService: OrganizationsService , private functionTypeService: FuncionTypeService,
               public dialog: MatDialog , public snackBar: MatSnackBar , private route: ActivatedRoute,  private fuseConfig: FuseConfigService, public toastr: ToastrService ) {
  }

  ngOnInit () {
    this.organizationService.getCountry().subscribe((result: any) => {
      this.countries = result;
      this.userService.getRoles().subscribe((roleResult: any) => {
        this.roles = roleResult;
        this.functionTypeService.getFunctionTypeDropDown().subscribe((resFunction: any) => {
          this.functions = resFunction;
          this.initForm();
        });
      });
    });
  }

  canDeactivate (): Observable<boolean> | boolean {
    return this.goBack();
  }

  initForm () {
    this.formGroup.controls.email.setValidators([ emailValidator , checkEmailOnServer ]);
    this.fuseConfig.role.subscribe(res => {
      this.adminRole = res;
      const selectControlCountry = this.formGroup.get('countryId');
      const selectControlCanton = this.formGroup.get('cityId');
      const selectControlOrganization = this.formGroup.get('organizationId');
      const selectControlLang = this.formGroup.get('lang');
      if (res && res === 'countryAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
        selectControlLang.enable({emitEvent: false});
      }
      if (res && res === 'subCountryAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
        selectControlLang.enable({emitEvent: false});
      }
      if (res && res === 'organisationAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
        selectControlOrganization.disable({emitEvent: false});
        selectControlLang.enable({emitEvent: false});
      }
    });
    this.formGroup.get('countryId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getCity(res).subscribe((result: any) => {
          this.cities = result;
          if (this.cityIdRoute) {
            this.formGroup.patchValue({cityId: +this.cityIdRoute});
          }
          if (this.cities.length === 1) {
            this.formGroup.patchValue({cityId: this.cities[ 0 ].id});
          }
        });
      }
    });

    this.formGroup.get('cityId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getOrganizationByCity(res).subscribe((result: any) => {
          this.organizations = result;
          this.formGroup.patchValue({organizationId: null});
          if (this.cityIdRoute) {
            this.formGroup.patchValue({organizationId: +this.orgIdRoute});
          }
          if (this.organizations.length === 1) {
            this.formGroup.patchValue({organizationId: this.organizations[ 0 ].id});
          }
        });
      }
    });


    this.formGroup.get('roleId').valueChanges.subscribe((res) => {
      const selectControlCountry = this.formGroup.get('countryId');
      const selectControlCanton = this.formGroup.get('cityId');
      const selectControlOrganization = this.formGroup.get('organizationId');
      if (res === 2) {
        selectControlCountry.setValidators(Validators.required);
        selectControlCanton.clearValidators({emitEvent: false});
        selectControlOrganization.clearValidators({emitEvent: false});
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
        selectControlOrganization.disable({emitEvent: false});
      } else if (res === 3) {
        selectControlCountry.setValidators(Validators.required);
        selectControlCanton.setValidators(Validators.required);
        selectControlOrganization.clearValidators({emitEvent: false});
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.disable({emitEvent: false});
      } else {
        selectControlCountry.setValidators(Validators.required);
        selectControlCanton.setValidators(Validators.required);
        selectControlOrganization.setValidators(Validators.required);
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
      }
      if (this.adminRole === 'countryAdmin') {
        selectControlCountry.disable({emitEvent: false});
      }
      if (this.adminRole === 'subCountryAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
      }
      if (this.adminRole === 'organisationAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
        selectControlOrganization.disable({emitEvent: false});
      }
      selectControlCountry?.updateValueAndValidity({emitEvent: false});
      selectControlCanton?.updateValueAndValidity({emitEvent: false});
      selectControlOrganization?.updateValueAndValidity({emitEvent: false});
    });

    this.formGroup.get('email').valueChanges.subscribe(res => {
      const errors = this.formGroup.controls.email.errors;
      if (!errors) {
        this.userService.checkEmailValid(res).subscribe((data: any) => {
          if (!data.valid) {
            this.formGroup.controls.email.setErrors({checkEmailOnServer: true});
          }
        });
      }
    });
    if (this.countries.length === 1) {
      this.formGroup.patchValue({countryId: this.countries[ 0 ].id});
      const countryControl = this.formGroup.get('countryId');
      countryControl.disable();
    }
    if (this.cities.length === 1) {
      this.formGroup.patchValue({cityId: this.cities[ 0 ].id});
    }
    if (this.organizations.length === 1) {
      this.formGroup.patchValue({organizationId: this.organizations[ 0 ].id});
    }

    this.route.queryParams.pipe(filter(params => params.country)).subscribe((params: any) => {
      if (params && params.subCountry) {
        this.cityIdRoute = params.subCountry;
        this.formGroup.patchValue({roleId: 4});
      }
      if (params && params.orgId) {
        this.orgIdRoute = params.orgId;
      }
      if (params && params.country) {
        this.formGroup.patchValue({countryId: +params.country});
      }

    });
    this.formGroup.patchValue({lang: 'de'});
  }

  addUser (returnToUser) {
    const dialogRef = this.dialog.open(FuseMailDialogComponent, {
      panelClass: 'unsave-form-dialog'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const data = this.formGroup.getRawValue();
        if (+data.roleId === 2) {
          data.cityId = '';
          data.organizationId = '';
        }
        if (+data.roleId === 3) {
          data.organizationId = '';
        }
        data.file = this.uploadedImg;
        if (result === 'yes') {
          data.sendInvite = true;
        }
        if (result === 'no') {
          data.sendInvite = false;
        }
        if (data.phone) {
          data.phone = data.phone.slice(0 , 16);
        }
        this.userService.addUser(data).subscribe((res) => {
          this.toastr.success('User added', 'Success!');
          this.returnBack = returnToUser;
          if (res && returnToUser) {
            this.userService.addSuccess = true;
            if (this.cityIdRoute) {
              this.router.navigate([ './pages/organization/detail' ] , {queryParams: {id: this.orgIdRoute}});
            } else {
              this.router.navigate([ './pages/users' ]);
            }
          }
        });
      }
    });

  }

  setImg (img) {
    this.uploadedImg = img;
  }

  goBack (): any {
    let dialogRef;
    if ((!this.compareForms() || this.uploadedImg) && !this.returnBack) {
      dialogRef = this.dialog.open(CheckModalComponent , {
        panelClass: 'unsave-form-dialog',
        width: '400px',
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.formGroup.valid) {
            this.addUser(false);
            return true;
          } else {
            this.snackBar.open('Please fill forms correctly' , '' , {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  compareForms () {
    const values = Object.values(this.formGroup.value);
    const changes = values.filter(x => x && x !== '');
    return changes.length ? false : true;
  }
}
